export const galleries_comm = [
    {
        id: "999",
        title: "Restaurants & Sports Bars",
        photos: "999",
    },
    {
        id: "998",
        title: "Conference Rooms",
        photos: "998",
    },
    {
        id: "997",
        title: "Houses of Worship",
        photos: "997",
    },
    {
        id: "996",
        title: "Night Clubs & Event Centers",
        photos: "996",
    },
    {
        id: "995",
        title: "Apartments & Multiple Dwelling Units",
        photos: "995",
    },
    // {
    //     id: "994",
    //     title: "Retail Stores",
    //     photos: "994",
    // },
    {
        id: "993",
        title: "Commercial-Grade Audio & Acoustic Reinforcement",
        photos: "993",
    },
    {
        id: "992",
        title: "Sound Masking & Speech Privacy",
        photos: "992",
    }
]